var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7965 5.19994L5.97733 1.94578C5.65233 1.57078 5.0565 1.57244 4.679 1.95078L2.36066 4.27328C1.67066 4.96411 1.47316 5.98994 1.87233 6.81244C4.25701 11.7499 8.23903 15.7375 13.1732 18.1291C13.9948 18.5283 15.0198 18.3308 15.7098 17.6399L18.0498 15.2958C18.429 14.9166 18.4298 14.3174 18.0515 13.9924L14.7848 11.1883C14.4432 10.8949 13.9123 10.9333 13.5698 11.2766L12.4332 12.4149C12.375 12.4759 12.2984 12.5161 12.2151 12.5294C12.1319 12.5426 12.0466 12.5282 11.9723 12.4883C10.1144 11.4184 8.57315 9.87513 7.50566 8.01578C7.46568 7.9414 7.45121 7.85597 7.46446 7.77257C7.4777 7.68918 7.51794 7.61244 7.579 7.55411L8.71233 6.41994C9.05566 6.07494 9.09316 5.54161 8.7965 5.19911V5.19994Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.eeccaf40.svg";
export { ForwardRef as ReactComponent };